import { render, staticRenderFns } from "./GadgetEditer3.vue?vue&type=template&id=b968f7c2&scoped=true&"
import script from "./GadgetEditer3.vue?vue&type=script&lang=ts&"
export * from "./GadgetEditer3.vue?vue&type=script&lang=ts&"
import style0 from "./GadgetEditer3.vue?vue&type=style&index=0&id=b968f7c2&lang=scss&scoped=true&"
import style1 from "./GadgetEditer3.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b968f7c2",
  null
  
)

export default component.exports